import styled from 'styled-components';

const Error = props => {
  // eslint-disable-next-line no-console
  props.error && console.log(`Error:  ${props.error}`);

  return (
    <>
      <div>An error has occurred. Please refresh and try again.</div>
      <div>
        If the problem persists, please{' '}
        <Link href="https://help.pluralsight.com/help/contact-feedback" target="_blank">
          contact support
        </Link>
        .
      </div>
    </>
  );
};

const Link = styled.a`
  text-decoration: underline;
  color: #fff;

  &:hover {
    color: #fff;
    text-decoration: underline;
  }
`;

export default Error;
